import { api } from "@/http/api-client"
import type { TListApiKeysResponse } from "./types"

export type TListApiKeysParams = {
  organizationSlug: string
}

export function listApiKeys(params: TListApiKeysParams) {
  return api.get<TListApiKeysResponse>(
    `/api-keys?organizationSlug=${params.organizationSlug}`,
  )
}
